module.exports = __webpack_public_path__ + "img/Day.87e64277.svg";